import { CartItem } from '@givebacks/api/store';

/**
 * Returns the display name of a cart item. If the item has a parent (e.g. an extra has a campaign it belongs to),
 * the parent item's name is included in the display name.
 *
 * @param item - The cart item to get the display name of.
 * @returns The display name of the cart item.
 */
const cartItemDisplayName = (item: CartItem) => {
  const showParentItem =
    item.reporting_store_item && item.reporting_store_item?.uuid !== item.store_item.uuid;
  return `${item.store_item.name} ${
    showParentItem ? `- ${item.reporting_store_item?.name}` : ''
  }`.trim();
};

export { cartItemDisplayName };
